import React, { memo, useState, useCallback } from 'react';
import Tab from '../Tab/Tab';
import TabPanel from '../TabPanel/TabPanel';
import './Tabs.css';

const Tabs = memo(({ 
  children, 
  defaultActiveTab,
  className = '',
  onTabChange 
}) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab || 0);

  const handleTabClick = useCallback((tabId) => {
    setActiveTab(tabId);
    if (onTabChange) {
      onTabChange(tabId);
    }
  }, [onTabChange]);

  // Extract tab data from children
  const tabs = React.Children.map(children, (child, index) => {
    if (React.isValidElement(child) && child.type === TabPanel) {
      return {
        id: child.props.tabId || index,
        label: child.props.label,
        disabled: child.props.disabled || false,
        content: child
      };
    }
    return null;
  }).filter(Boolean);

  return (
    <div className={`tabs ${className}`}>
      <div className="tabs__header">
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            id={tab.id}
            label={tab.label}
            isActive={activeTab === tab.id}
            onClick={handleTabClick}
            disabled={tab.disabled}
          />
        ))}
      </div>
      
      <div className="tabs__content">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`tabs__panel ${activeTab === tab.id ? 'tabs__panel--active' : ''}`}
            role="tabpanel"
            aria-hidden={activeTab !== tab.id}
          >
            {activeTab === tab.id && tab.content}
          </div>
        ))}
      </div>
    </div>
  );
});

Tabs.displayName = 'Tabs';

export default Tabs;
